export default __webpack_public_path__ + "static/media/TransportationCars_07.9db99cb5.png";